import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Loader from '../../../components/common/Loader';
import { GLOBAL_DEFAULT } from '../../../constants/global';
import { orderService } from '../services';
import PrintPackaginSlipFitCrunch from './printPackaginSlipFitCrunch';
import PrintPackaginSlipMIXT from './printPackagingSlipMIXT';

const PrintShippingLabel: React.FC<any> = () => {
    const [state, setState] = useState<any>(null);
    const [orderDetail, setOrderDetail] = useState<any>();
    const [loading, setLoading] = useState<boolean>(GLOBAL_DEFAULT.LOADER_STATE);

    useEffect(() => {
        try {
            const windowName = window.name;
            const state = JSON.parse(windowName);

            setState(state);
        } catch (error) {
            console.error('Failed to parse state from window name', error);
            window.location.href = '/app/dashboard';
        }
    }, []);

    const getOrderDetail = useCallback(async () => {
        if (state?.orderId) {
            setLoading(true);
            try {
                const payload = {
                    orderIds: state?.orderId,
                    type: state?.orderType || 'Orders'
                }
                const response = await orderService.printPackingSlip(payload);

                const orderDetail = response?.data?.map((order: any) => {
                    if(state?.orderType === 'OrdersArchive') {
                        order.recipient = {
                            name: order.recipient_name,
                            address: order.recipient_address,
                            city: order.recipient_city,
                            country: order.recipient_country,
                            state: order.recipient_state,
                            zip_code: order.recipient_zip_code,
                            phone: order.recipient_phone,
                            email: order.recipient_email,
                        }
                    }

                    return {
                        ...order,
                        is_shipping_label: order?.shipping?.packages?.some((packageItem: any) => packageItem?.label_download?.png)
                    }
                });

                setOrderDetail(orderDetail);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        }

    }, [state?.orderId, state?.orderType]);

    useEffect(() => {
        getOrderDetail();

    }, [getOrderDetail]);

    return <>
        <Loader isLoading={loading} />
        <div className='text-center hide-on-print py-3'><Button className='custom-min-width-85' size='sm' variant="dark" onClick={() => window.print()}>Print</Button></div>
        {orderDetail?.map((orderDetails: any, index: any) => (

            <div key={index} style={{ pageBreakBefore: 'always', lineHeight: 1.2 }}>
                {orderDetails?.is_shipping_label ?
                    <>
                        {orderDetails?.shipping?.packages?.map((package_label: any, packageLabelIndex: any) => {
                            return <div key={packageLabelIndex} style={{ textAlign: 'center', pageBreakInside: "avoid" }}>
                                <img
                                    src={package_label?.label_download?.png}
                                    alt="Shipping Label"
                                    width={576}
                                    height={1020}
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100vh',
                                        height: 'auto',
                                        pageBreakInside: "avoid",
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>;
                        })}
                    </> :
                    <>
                        <div style={{ textAlign: 'center', pageBreakInside: "avoid" }}>
                            <img
                                src={orderDetails?.shipping?.label_download?.png}
                                alt="Shipping Label"
                                width={576}
                                height={1020}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100vh',
                                    height: 'auto',
                                    pageBreakInside: "avoid",
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </>
                }
                {
                    [43, 46, 47, 82, 83, 84, 85, 147].includes(orderDetails?.sales_channel_id) ?
                        <PrintPackaginSlipFitCrunch orderDetails={orderDetails} />
                        :
                        <PrintPackaginSlipMIXT orderDetails={orderDetails} />
                }
            </div>
        ))}
    </>;
}

export default PrintShippingLabel;